module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/public/public.component.html
// module id = ./src/app/public/public.component.html
// module chunks = main